import type { FaireProductEntity } from "../../entity_types/product";

export const p_u7fvcdrd32: FaireProductEntity = {
  token: "p_u7fvcdrd32",
  type: "product",
  name: "Cinnamon Gingerbread Power Mist Hydrating Hand Sanitizer",
  brandToken: "b_evrq835k7x",
  brandName: "Touchland",
  imageUrl: "https://cdn.faire.com/fastly/d9cc65b7194bb3f658364d221d2e273242aba29a060193f55c67e9328ea6f5c6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a9fb91ad994f09b470c8444700df7ff5244ccd614829e9823068d03a9a952f7f.png",
    "https://cdn.faire.com/fastly/6f66a8fafa44633f74d7dfc797c5970f9195d7b952fb4d766fec119c8347242e.png",
    "https://cdn.faire.com/fastly/b7d7dc65b823b036763c7752d89b16724327e870cb6cadd083f0a8e513c56e60.png",
    "https://cdn.faire.com/fastly/b41c75d9029d8dedd43a5dd0dc021d373dba76dd85b1ad32c1e98b60b6c8aea7.png"
  ],
  priceDollars: 6,
  description: "A skincare-forward hand sanitizer that leaves hands sanitized, hydrated, and delicately scented.\n\nCinnamon Gingerbread Scent: Indulgent and cozy. Spiced gingerbread intertwines with the richness of cinnamon sugar and vanilla glaze, evoking the comforting decadence of a warm holiday treat.\n\nTop Notes: Gingerbread Spice, Clove Bud\nHeart Notes: Caramel Swirl, Cinnamon Sugar\nBase Notes: Vanilla Glaze, Brown Sugar\n\nMain Ingredients:\n• Alcohol: Effective against most common bacteria.\n• Aloe Vera: Helps hydrate skin and leaves a non-greasy finish.\n• Radish Root Ferment Filtrate: Helps enhance skin’s moisture retention.\n\nBenefits:\n• Hydrating - Enriched with Aloe Vera to help hydrate skin.\n• Lightweight - Non-sticky and fast-absorbing formula delivered in a micro-mist.\n• Free from phthalates and sulfates.\n• Vegan and cruelty-free.\n• Dermatologically tested.\n• Travel-friendly 1 fl. oz. (30 mL).",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:35.195Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
